<mat-chip-list>
  <mat-chip *ngFor="let item of items" [removable]="true" color="primary" selected (removed)="remove(item.id)">
    {{item.name}}
    <mat-icon matChipRemove>close</mat-icon>
  </mat-chip>
</mat-chip-list>